import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=8a4cc334&"
import script from "./StudentEdit.vue?vue&type=script&lang=js&"
export * from "./StudentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports